
import Icon from "../../../../public/assets/images/keinternational/true.png"
import { FaPlus } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

const cardsData = [
  {
    number: "25%",
    headline: "of anonymous shoppers identified with KwikPass"
  },
  {
    number: "20%+",
    headline: "Abandoned cart recovery"
  },
  {
    number: "3X",
    headline: "User engagement",

  },
  {
    number: "20X",
    headline: "ROAS",

  },
];


const cardsData2 = [
  {
    icon: "assets/images/keinternational/shield.svg",
    headline: "GDPR Compliant",
  },
  {
    icon: "assets/images/keinternational/text.svg",
    headline: "Smart, contextual messages only. No cold outreach",
  },
  {
    icon: "assets/images/keinternational/user.svg",
    headline: "<5% opt-out rate across a 165M+ shopper network",
  },

];


const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });




export const SectionFour = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="section-four-a-Ind">
      <div className="container-fluid">
        <div className="heading-Ind" style={{ marginLeft: isMobile ? '0.2rem' : "6rem", textAlign: 'center' }}>
          <h1 className="suite-title-Ind" style={{ color: "black", fontWeight: "400" }}>
            GoKwik's 165M+ Shoppers <br />Network Effect
          </h1>
          <p className="suite-tagline-Ind">
            Leverage the most extensive network of online shoppers <br /> to boost engagement and conversions
          </p>

        </div>
        <div className="feature-grid-Ind">
          {cardsData.map((card, idx) => (
            <div className="feature-card-Ind" key={idx}>

              <div className="feature-headline-Ind">{card.number}</div>
              <div className="feature-cta-Ind">{card.headline}</div>
            </div>
          ))}
        </div>


        <div className="quote1">
          <img src="assets/images/keindia/quote.png" alt="" />
          <h4 className="quotes1">The biggest win with GoKwik is the 360° approach. We no longer <br />juggle 10 tools — now everything we need is in one place.</h4>

          <p className="owner">Prabhu Shetty, Head of Marketing & Retail,  Bonkers Corner</p>

          <img style={{marginTop:"15px"}} src="assets/images/keindia/bonkercorner.png" alt="" />
        </div>
      </div>
    </div>



  )
};
